import cx from 'classnames';
import { myBrowserHistory } from '../ApplicationState';
import { Segment, VerticalSpacer } from './../core/core';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import elementaryStudentScreenshot from '../images/example-students.png';
import secondaryStudentScreenshot from '../images/example-students-secondary.png';
import styles from '../SCSS/ClassroomDashboard.module.scss';
import utilityStyles from '../SCSS/common/utilityStyles.module.scss';
import segmentStyles from '../SCSS/Segment.module.scss';

interface Props {
  grade: number;
}

const MarketingStudents = (props: Props): JSX.Element => {
  return (
    <>
      <div className={`${styles.ClassroomDashboard} ${utilityStyles.clearfix}`}>
        <VerticalSpacer ems={2} />
        <Segment className={utilityStyles.line}>
          <div className={segmentStyles.moduleTitle}>Students Example</div>
        </Segment>
        <Segment className={utilityStyles.line}>
          <div className={styles.marketingCopy}>
            {props.grade < 6 ? (
              <>
                <p>
                  At your current access level, you do not need to set up students, as student access to myPeekaville is
                  a Peekapak PRO feature.
                </p>

                <p>
                  Curious to try out myPeekaville and other Peekapak PRO features? Why not start a free 14-day trial?
                </p>
              </>
            ) : (
              <>
                <p>
                  At your current access level, you do not need to add students to your classroom, as student access is
                  a Peekapak PRO feature.
                </p>

                <p>
                  Curious to try out the student experience and other Peekapak PRO features? Why not start a free 14-day
                  trial?
                </p>
              </>
            )}
            <div className='ctaButton'>
              <PrimaryButton onClick={() => myBrowserHistory.push('/activateTrial')}>Start Trial</PrimaryButton>
            </div>
          </div>
          <img
            alt='Screenshot'
            className={cx(styles.marketingImg, utilityStyles.marketingScreenshot)}
            src={props.grade < 6 ? elementaryStudentScreenshot : secondaryStudentScreenshot}
          />
        </Segment>
      </div>
    </>
  );
};

export default MarketingStudents;
